let options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
}

const callback = (entries, observer) => {
    entries.forEach((entry) => {
        let stickyCart = document.querySelector(".sticky-cart")

        if(!entry.isIntersecting) {
            stickyCart.classList.remove("no-visible")
        }
        if(entry.isIntersecting && (entry.target.classList.contains("product__info-container") || entry.target.classList.contains("product"))) {
            stickyCart.classList.add("no-visible")
        }
        if(entry.isIntersecting && entry.target.classList.contains("footer")) {
            stickyCart.classList.add("no-visible")
        }
    })
}

let observer = new IntersectionObserver(callback, options)
let target = window.innerWidth < 750 ? document.querySelector(".product") : document.querySelector(".product__info-container")
let footer = document.querySelector(".footer")

observer.observe(footer)
observer.observe(target)